import type { Address } from "../types/address.type";
import type { Cart } from "../types/cart.type";

export interface CheckoutProps {
  cart: Cart | null;
  loadingCart: boolean;
  addresses: Address[];
  isAddressesLoading: boolean;
}

export interface ShippingOption {
  id: string;
  name: string;
  timeframe: string;
  price: string;
  selected?: boolean;
}

export const CHECKOUT_STEPS = {
  ADDRESS: 1,
  SHIPPING: 2,
  PAYMENT: 3,
  SUMMARY: 4,
} as const;
